var _circle, _circle2, _path, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRohs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 46,
    fill: "#F0FDF4",
    stroke: "#22C55E",
    strokeWidth: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 31,
    fill: "#FFFFFF",
    stroke: "#22C55E",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 49L44 57L60 39",
    stroke: "#16A34A",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 74,
    textAnchor: "middle",
    fontFamily: "Segoe UI, Arial",
    fontSize: 12,
    fontWeight: 800,
    fill: "#16A34A"
  }, "RoHS")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRohs);
export default __webpack_public_path__ + "static/media/rohs.6f0d516255585bb8c8af15aadf85ff12.svg";
export { ForwardRef as ReactComponent };